import React from "react";
import { Modal } from "@themesberg/react-bootstrap";

const ImageModal = ({ show, setShow, imageUrl, altText = "Preview" }) => {
  return (
    <Modal show={show} onHide={() => setShow(false)} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex justify-content-center align-items-center"
        style={{ backgroundColor: "black", minHeight: "250px" }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={altText}
            style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: "8px" }}
          />
        ) : (
          <p className="text-white m-0">Image not available</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ImageModal;

